import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    redirectTo: "inspections",
    pathMatch: "full",
  },
  {
    path: "session",
    loadChildren: () =>
      import("./session/session.module").then((m) => m.SessionModule),
  },
  {
    path: "inspections",
    loadChildren: () =>
      import("./inspection/inspection.module").then((m) => m.InspectionModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { paramsInheritanceStrategy: "emptyOnly" }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
